import { render, staticRenderFns } from "./creatMessage.vue?vue&type=template&id=b7582608&scoped=true&"
import script from "./creatMessage.vue?vue&type=script&lang=ts&"
export * from "./creatMessage.vue?vue&type=script&lang=ts&"
import style0 from "./creatMessage.vue?vue&type=style&index=0&id=b7582608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7582608",
  null
  
)

export default component.exports